module.exports = __webpack_public_path__ + "media/images/area/area_hyogoM400-2b591a5a90b2384d1135bd00621a5507.jpg";